import { Command, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import {
    AbstractViewContribution,
    CommonMenus,
    FrontendApplication,
    FrontendApplicationContribution
} from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { ProjectOverview } from './project-overview';

const ProjectOverviewCommand: Command = {
    id: 'lvgl:project-overview',
    label: 'Project Overview'
};

@injectable()
export class ProjectOverviewContribution
    extends AbstractViewContribution<ProjectOverview>
    implements FrontendApplicationContribution, MenuContribution
{
    constructor() {
        super({
            widgetId: ProjectOverview.ID,
            widgetName: ProjectOverview.LABEL,
            defaultWidgetOptions: { area: 'main' }
        });
    }

    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        await this.openView({ activate: true, reveal: true });
    }

    override registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(ProjectOverviewCommand, {
            execute: async () => {
                const widget = await this.widgetManager.getOrCreateWidget<ProjectOverview>(ProjectOverview.ID);
                await this.shell.activateWidget(widget.id);
            }
        });
    }

    override registerMenus(menus: MenuModelRegistry): void {
        menus.registerMenuAction(CommonMenus.VIEW_VIEWS, {
            commandId: ProjectOverviewCommand.id,
            label: 'Project Overview',
            order: '0'
        });
    }
}
